import { render, staticRenderFns } from "./content-detail.vue?vue&type=template&id=4c00fc66&"
import script from "./content-detail.vue?vue&type=script&lang=js&"
export * from "./content-detail.vue?vue&type=script&lang=js&"
import style0 from "./content-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-detail.vue"
export default component.exports